module.exports = __webpack_public_path__ + "img/spinner.431b7fae.gif";